import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as aiBuilderActions from '../actions/ai-builder.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadBuilderCreatedPages} from '../actions';
import {AiBuilderService} from "../../websites/website/ai-builder/service/ai-builder.service";
import {LoadGeneratedWebsiteCount} from "../actions/ai-builder.action";

interface SuccessGeneratedCount {
  status: string;
  count: number;
  can_regenerate: boolean;
}

@Injectable()
export class AiBuilderEffects {

  constructor(
    private _actions$: Actions,
    private _hostingService: AiBuilderService
  ) {
  }

  /* @Effect() updateWebsiteSubData$ = this._actions$.ofType(UPDATE_WEBSITE_SUB_DATA)
     .pipe(
       filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
       map((action: UpdateWebsiteSubData) => {
         return new hostingRedirectsActions.LoadRedirects(action.payload.id);
       })
     );*/

  loadBuilderCreatedPages$ = createEffect(() => this._actions$.pipe(
    ofType(aiBuilderActions.LOAD_BUILDER_CREATED_PAGES),
    mergeMap((action: LoadBuilderCreatedPages) => {
      return this._hostingService.getCreatedPages(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new aiBuilderActions.LoadBuilderCreatedPagesSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new aiBuilderActions.LoadBuilderCreatedPagesFails(response.message);
          })
        );
    })
  ));

  loadGeneratedWebsitesCount$ = createEffect(() => this._actions$.pipe(
    ofType(aiBuilderActions.LOAD_GENERATED_WEBSITES_COUNT),
    mergeMap((action: LoadGeneratedWebsiteCount) => {
      return this._hostingService.getGeneratedWebsiteCount()
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new aiBuilderActions.LoadGeneratedWebsiteCountSuccess({
                count: (response.data as SuccessGeneratedCount).count,
                can_regenerate: !!(response.data as SuccessGeneratedCount).can_regenerate
              });
            }
            return new aiBuilderActions.LoadGeneratedWebsiteCountFail(response.message);
          })
        );
    })
  ));


}
